import(/* webpackMode: "eager", webpackExports: ["FooterIt"] */ "/vercel/path0/src/components/it/footerIt.comp.tsx");
